import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  EProductCategoryGroupSortField,
  IProductCategoryGroup,
  PProductCategoryGroupFilter,
} from "src/core/productCategoryGroup/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IProductCategoryGroupState {
  productCategoryGroups: IProductCategoryGroup[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IProductCategoryGroupState = {
  productCategoryGroups: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "product-category-group/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "product-category-group/FETCH_SUCCEEDED";
const FETCH_FAILED = "product-category-group/FETCH_FAILED";
const POLLING_START_REQUESTED =
  "product-category-group/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "product-category-group/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IProductCategoryGroup[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PProductCategoryGroupFilter;
    pagination: IPagination;
    sorts: ISort<EProductCategoryGroupSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IProductCategoryGroupState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IProductCategoryGroupState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.productCategoryGroups = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
